/* eslint-disable react/jsx-max-depth */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useEffect, useState, useRef, useMemo } from 'react';
import { Formik } from 'formik';
import isEmpty from 'lodash/isEmpty';
import { Col, Row } from 'react-bootstrap';
import { PulseLoader } from 'react-spinners';
import { useDispatch } from 'react-redux';
import FormSection from '../../../components/containers/FormSection';
import Control from '../../../components/form/Control';
import Icon from '../../../components/icon/Icon';
import { IMAGE_CROPPER_MODAL } from '../../../components/modal/ImageCropper';
import { showModal } from '../../../redux/actions';
import { useGetCompanyProfileQuery, useUpdateCompanyProfileMutation } from '../../../redux/rtk';
import text from '../../../text';
import { checkFieldsAreDiff } from '../../../utilities/object';
import { companyFormSchema, SPECIALIZATION_MAX_LENGTH } from '../../../validation';
import AutoSave from './AutoSave';
import classNames from 'classnames';
import useUser from '../../../mp/hooks/useUser';
var CompanyForm = function() {
    var dispatch = useDispatch();
    var _useUser = useUser(), isGovernment = _useUser.isGovernment, hasValidMembership = _useUser.hasValidMembership, isAdmin = _useUser.isAdmin, isStaff = _useUser.isStaff, isUserUnderTrial = _useUser.isUserUnderTrial;
    var _useGetCompanyProfileQuery = useGetCompanyProfileQuery(), companyProfile = _useGetCompanyProfileQuery.data, isLoadingProfile = _useGetCompanyProfileQuery.isLoading;
    var _useUpdateCompanyProfileMutation = _sliced_to_array(useUpdateCompanyProfileMutation(), 1), updateCompanyProfile = _useUpdateCompanyProfileMutation[0];
    var imgRef = useRef(null);
    var _useState = _sliced_to_array(useState(true), 2), isImageLoading = _useState[0], setIsImageLoading = _useState[1];
    // Force reload the image when the logo_url changes
    useEffect(function() {
        if (!isEmpty(companyProfile === null || companyProfile === void 0 ? void 0 : companyProfile.logo_url) && imgRef.current) {
            var newImg = new Image();
            newImg.onload = function() {
                imgRef.current.src = companyProfile.logo_url;
            };
            newImg.src = companyProfile.logo_url;
        }
    }, [
        companyProfile === null || companyProfile === void 0 ? void 0 : companyProfile.logo_url
    ]);
    var handleSubmit = function(values, actions) {
        var diffFields = checkFieldsAreDiff(companyProfile, values);
        if (Object.entries(diffFields).some(Boolean)) {
            var logo_url = values.logo_url, rest = _object_without_properties(values, [
                "logo_url"
            ]);
            updateCompanyProfile(rest);
            actions.resetForm({
                values: values,
                touched: diffFields
            });
        }
    };
    var handleEditLogoClicked = function() {
        dispatch(showModal(IMAGE_CROPPER_MODAL));
    };
    var isCompanyDetailsEditable = useMemo(function() {
        return isGovernment || hasValidMembership && !isUserUnderTrial || isAdmin || isStaff;
    }, [
        hasValidMembership,
        isGovernment,
        isUserUnderTrial,
        isAdmin,
        isStaff
    ]);
    return !isEmpty(companyProfile) && !isLoadingProfile && /*#__PURE__*/ React.createElement(FormSection, {
        title: text('companyDetails'),
        className: "company-form"
    }, /*#__PURE__*/ React.createElement(Formik, {
        validationSchema: companyFormSchema,
        initialValues: companyProfile,
        onSubmit: handleSubmit
    }, function(param) {
        var company = param.values, handleBlur = param.handleBlur, handleChange = param.handleChange, touched = param.touched, isValid = param.isValid, errors = param.errors;
        var isFormTouched = touched && Object.values(touched).some(Boolean);
        var _company_name, _company_specialization, _company_specialization1, _company_address, _company_phone, _company_website, _company_business_number;
        return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Row, null, /*#__PURE__*/ React.createElement(Col, {
            md: "6"
        }, /*#__PURE__*/ React.createElement(Control, {
            isSuccessful: touched.name,
            isFailed: !!(isFormTouched && errors.name),
            as: "input",
            type: "text",
            name: "name",
            value: (_company_name = company.name) !== null && _company_name !== void 0 ? _company_name : '',
            label: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("span", {
                className: "mr-1"
            }, text('companyName')), /*#__PURE__*/ React.createElement("span", {
                className: "font-weight-normal"
            }, "(", text('shownOnAd'), ")")),
            onBlur: handleBlur,
            onChange: handleChange,
            validationError: errors.name,
            placeholder: text('companyNamePlaceholder'),
            required: true
        }), isCompanyDetailsEditable ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Control, {
            isSuccessful: touched.specialization,
            isFailed: !!(isFormTouched && errors.specialization),
            as: "textarea",
            id: "specialization",
            name: "specialization",
            value: (_company_specialization = company.specialization) !== null && _company_specialization !== void 0 ? _company_specialization : '',
            label: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("span", {
                className: "mr-1"
            }, text('companySpecialization')), /*#__PURE__*/ React.createElement("span", {
                className: "font-weight-normal"
            }, "(", text('shownOnAd'), ")")),
            validationError: errors.specialization,
            placeholder: text('companySpecializationPlaceholder'),
            maxLength: SPECIALIZATION_MAX_LENGTH,
            className: "Specialization",
            onBlur: handleBlur,
            onChange: handleChange,
            isControlFeedbackHidden: true,
            hint: "".concat(((_company_specialization1 = company.specialization) !== null && _company_specialization1 !== void 0 ? _company_specialization1 : '').length, "/").concat(SPECIALIZATION_MAX_LENGTH, " characters")
        }), /*#__PURE__*/ React.createElement(Control, {
            isSuccessful: touched.address,
            isFailed: !!(isFormTouched && errors.address),
            as: "input",
            type: "text",
            name: "address",
            value: (_company_address = company.address) !== null && _company_address !== void 0 ? _company_address : '',
            label: text('companyAddress'),
            validationError: errors.address,
            placeholder: text('companyAddressPlaceholder'),
            onBlur: handleBlur,
            onChange: handleChange
        }), /*#__PURE__*/ React.createElement(Control, {
            isSuccessful: !!(touched.phone && !errors.phone),
            isFailed: !!(isFormTouched && errors.phone),
            as: "input",
            type: "text",
            name: "phone",
            value: (_company_phone = company.phone) !== null && _company_phone !== void 0 ? _company_phone : '',
            label: text('companyPhone'),
            validationError: errors.phone,
            placeholder: text('companyPhonePlaceholder'),
            onBlur: handleBlur,
            onChange: handleChange
        })) : null), isCompanyDetailsEditable ? /*#__PURE__*/ React.createElement(Col, {
            md: "6"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "CompanyLogo"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "label"
        }, /*#__PURE__*/ React.createElement("span", {
            className: "font-weight-bold mr-1"
        }, text('companyLogo')), /*#__PURE__*/ React.createElement("span", {
            className: "font-weight-normal"
        }, "(", text('shownOnAd'), ")")), /*#__PURE__*/ React.createElement("div", {
            className: "d-flex flex-row align-items-center"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "position-relative"
        }, /*#__PURE__*/ React.createElement("img", {
            ref: imgRef,
            src: !isEmpty(company.logo_url) && !isImageLoading ? company.logo_url : '/public/img/your_logo_placeholder.svg',
            alt: !isEmpty(company.logo_url) ? 'company logo' : 'your_logo_placeholder',
            className: classNames('mr-3 company-logo-holder', {
                objectFitContain: !isEmpty(company.logo_url),
                objectFitInitial: isEmpty(company.logo_url)
            }),
            loading: "eager",
            decoding: "sync",
            onLoad: function() {
                return setIsImageLoading(false);
            },
            style: {
                opacity: isImageLoading ? 0.3 : 1
            }
        }), isImageLoading ? /*#__PURE__*/ React.createElement("div", {
            className: "position-absolute d-flex align-items-center justify-content-center image-loader-container"
        }, /*#__PURE__*/ React.createElement(PulseLoader, {
            size: 8,
            color: "#31a283"
        })) : null), /*#__PURE__*/ React.createElement(Icon, {
            icon: "edit",
            onClick: handleEditLogoClicked
        }))), /*#__PURE__*/ React.createElement(Control, {
            isSuccessful: touched.website,
            isFailed: !!(isFormTouched && errors.website),
            as: "input",
            type: "text",
            name: "website",
            value: (_company_website = company.website) !== null && _company_website !== void 0 ? _company_website : '',
            label: text('companyWebsite'),
            validationError: errors.website,
            placeholder: text('companyWebsitePlaceholder'),
            onBlur: handleBlur,
            onChange: handleChange
        }), /*#__PURE__*/ React.createElement(Control, {
            isSuccessful: touched.business_number,
            isFailed: !!(isFormTouched && errors.business_number),
            as: "input",
            type: "text",
            name: "business_number",
            value: (_company_business_number = company.business_number) !== null && _company_business_number !== void 0 ? _company_business_number : '',
            label: text('businessNumber'),
            validationError: errors.business_number,
            placeholder: text('companyBusinessNoPlaceholder'),
            onBlur: handleBlur,
            onChange: handleChange
        })) : null), /*#__PURE__*/ React.createElement(AutoSave, {
            isValidForm: isValid
        }));
    }));
};
export default CompanyForm;
